export default "__VITE_PUBLIC_ASSET__963a3a58__"